<!--设备属性编辑界面-->
<template>
  <div class="archiverstype">
    <div class="con">
      <div class="left-tree">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText"> </el-input>
        <div class="btns">
          <el-button type="primary" size="mini" @click="addSuperiorShow=true,addType='同级'">新增同级</el-button>
          <el-button type="primary" size="mini" @click="newAddSuperior">新增子级</el-button>
        </div>
        <el-scrollbar style="height:calc(100% - 60px);width: 100%;">
          <el-tree :data="getEntityTypeList" :default-expanded-keys="[2]" :expand-on-click-node="true" node-key="id"
            :props="defaultProps" :highlight-current='true' :filter-node-method="filterNode" ref="tree"
            @node-click="checkItem">
            <span class="custom-tree-node" slot-scope="{node}">
              <img v-if="node.data.typeEnum == 0" src="../../../public/static/image/elTree/2.0.png" />
              <img v-else src="../../../public/static/image/elTree/variable.png" />
              <span style="padding:0px  5px;">{{node.data.typeName }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </div>
      <div class="right-table">
        <div class="top-table">
          <div class="Files-top">
            <div class="ic-left">
              <span>设备详情</span>
            </div>
            <div class="btns"></div>
          </div>
          <el-table :data="treeTableList" height="90" stripe style="width: 100%;margin-top: 10px;" border>
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据">
                <span class="text">暂无数据</span>
              </span>
            </template>
            <el-table-column type="index" width="50" align="center">
            </el-table-column>
            <el-table-column prop="mainTypeCode" label="上级类型编码" align="center">
            </el-table-column>
            <el-table-column prop="typeCode" label="类型编码" align="center">
            </el-table-column>
            <el-table-column prop="typeName" label="类型名称" align="center">
            </el-table-column>
            <el-table-column prop="editable" label="是否可编辑" :formatter="formatEditable" align="center">
            </el-table-column>
            <el-table-column label="操作" width='250' prop='editable' align="center" fixed="right">
              <template #default="{row}">
                <div class="public-flex">
                  <div @click="editSuperior(row)" class="mr-20">
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                      <elIconBtn btnType='edit'></elIconBtn>
                    </el-tooltip>
                  </div>
                  <div @click="deleteArchives('上级',row)">
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                      <elIconBtn btnType='del'></elIconBtn>
                    </el-tooltip>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="bottom-table">
          <div class="Files-top">
            <div class="ic-left">
              <span>设备属性</span>
            </div>
            <div class="btns"><el-button type="primary" @click='addPropertyShow=true' class="last-el-button"
                :disabled='typeEnum == 0'>添加属性</el-button></div>
          </div>
          <div class="search-input-btn" style="width:100%">
            <div class="input-small">
              <span>名称：</span>
              <el-input v-model="search" clearable placeholder="请输入名称"></el-input>
            </div>
            <el-button type="primary" plain @click="search_fn" class="search-btn">查询</el-button>
          </div>
          <div class="my-table">
            <el-table :data="attributesList" :height="heights" stripe style="width: 100%;margin-top: 10px;" border>
              <template slot="empty">
                <span class="noData">
                  <img src="@/assets/noData.png" alt="暂无数据">
                  <span class="text">暂无数据</span>
                </span>
              </template>
              <el-table-column type="index" width="50" align="center">
              </el-table-column>
              <el-table-column prop="propertyName" label="属性名称" align="center">
              </el-table-column>
              <el-table-column prop="typePropertyCode" label="属性编码" align="center">
              </el-table-column>
              <el-table-column prop="valueType" label="值类型" :formatter="formatValueType" align="center">
              </el-table-column>
              <el-table-column prop="defaultValue" label="默认值" align="center">
              </el-table-column>
              <el-table-column prop="editable" label="是否可编辑" :formatter="formatEditable" align="center">
              </el-table-column>
              <el-table-column prop="isOnly" label="值是否唯一" :formatter="formatterIsOnly" align="center">
              </el-table-column>
              <el-table-column prop="nullable" label="是否可以为空" :formatter="formatterNullable" align="center">
              </el-table-column>
              <el-table-column label="操作" width='180' align="center" fixed="right">
                <!-- <template slot-scope="scope">
                            <span style=" display: flex;justify-content: center;align-items: center;">
                              <el-button size="mini" type="text" @click="editClick(scope.row)"
                                :disabled="scope.row.editable==1?false:true" style="color:#409eff;font-weight:700">编辑</el-button>
                              <span class="line"></span>
                              <el-button size="mini" type="text" @click="deleteArchives('属性',scope.row)"
                                :disabled="scope.row.editable==1?false:true" style="color:#ff7765;font-weight:700">删除</el-button>
                            </span>
                          </template> -->
                <template #default="{row}">
                  <div class="public-flex">
                    <div @click="editClick(row)" class="mr-20">
                      <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                        <elIconBtn btnType='edit'></elIconBtn>
                      </el-tooltip>
                    </div>
                    <div @click="deleteArchives('属性',row)">
                      <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <elIconBtn btnType='del'></elIconBtn>
                      </el-tooltip>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>


      </div>
      <el-dialog title="编辑类型" :visible.sync="editSuperiorShow">
        <el-form :model="editSuperiorForm">
          <el-form-item label="类型名称" label-width="120px">
            <el-input v-model="editSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="是否为目录" label-width="120px" prop="editable">
            <el-radio v-model="editSuperiorForm.typeEnum" label="0">是</el-radio>
            <el-radio v-model="editSuperiorForm.typeEnum" label="1">否</el-radio>
          </el-form-item>
          <!--				<el-form-item label="支持排名" label-width="120px">-->
          <!--					<el-radio v-model="editSuperiorForm.isRank" label="1">是</el-radio>-->
          <!--					<el-radio v-model="editSuperiorForm.isRank" label="0">否</el-radio>-->
          <!--				</el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editSuperiorShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmSuperiorForm()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="编辑属性" :visible.sync="propertyShow">
        <el-form :model="editPropertyForm" :rules="editRules" ref="editPropertyForm">
          <el-form-item label="属性名称" label-width="120px" prop="propertyName">
            <el-input v-model="editPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="值类型" label-width="120px" prop="valueType">
            <el-select v-model="editPropertyForm.valueType" placeholder="请选择值类型" style="width: 70%;">
              <el-option :label="item.text" :value="item.value" v-for='item in getValueEnum'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="默认值" label-width="120px" prop="defaultValue">
            <el-input v-model="editPropertyForm.defaultValue" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="是否可编辑" label-width="120px" prop="editable">
            <el-radio v-model="editPropertyForm.editable" label="1">是</el-radio>
            <el-radio v-model="editPropertyForm.editable" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="值是否唯一" label-width="120px" prop="isOnly">
            <el-radio v-model="editPropertyForm.isOnly" label="1">是</el-radio>
            <el-radio v-model="editPropertyForm.isOnly" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="是否允许为空" label-width="120px" prop="nullable">
            <el-radio v-model="editPropertyForm.nullable" label="1">是</el-radio>
            <el-radio v-model="editPropertyForm.nullable" label="0">否</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="propertyShow = false">取 消</el-button>
          <el-button type="primary" @click="editPropertyConfirm()">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加类型" :visible.sync="addSuperiorShow">
        <el-form :model="addSuperiorForm" :rules="addRules">
          <el-form-item label="类型名称" label-width="120px">
            <el-input v-model="addSuperiorForm.typeName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="类型编码" label-width="120px">
            <el-input v-model="addSuperiorForm.typeCode" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="是否有子级" label-width="120px" prop="editable">
            <el-radio v-model="addSuperiorForm.typeEnum" label="0">有</el-radio>
            <el-radio v-model="addSuperiorForm.typeEnum" label="1">无</el-radio>
          </el-form-item>
          <!--				<el-form-item label="支持排名" label-width="120px">-->
          <!--					<el-radio v-model="addSuperiorForm.isRank" label="1">是</el-radio>-->
          <!--					<el-radio v-model="addSuperiorForm.isRank" label="0">否</el-radio>-->
          <!--				</el-form-item>-->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addSuperiorShow = false">取 消</el-button>
          <el-button type="primary" @click="addConfirm">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="添加属性" :visible.sync="addPropertyShow">
        <el-form :model="addPropertyForm" :rules="rules" ref="addPropertyForm">
          <el-form-item label="属性名称" label-width="120px" prop="propertyName">
            <el-input v-model="addPropertyForm.propertyName" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="属性编码" label-width="120px" prop="typeCode">
            <el-input v-model="addPropertyForm.typeCode" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="值类型" label-width="120px" prop="valueType">
            <el-select v-model="addPropertyForm.valueType" placeholder="请选择值类型" style="width: 70%;">
              <el-option :label="item.text" :value="item.value" v-for='item in getValueEnum'></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="默认值" label-width="120px" prop="defaultValue">
            <el-input v-model="addPropertyForm.defaultValue" auto-complete="off" style="width:70%;"></el-input>
          </el-form-item>
          <el-form-item label="是否可编辑" label-width="120px" prop="editable">
            <el-radio v-model="addPropertyForm.editable" label="1">是</el-radio>
            <el-radio v-model="addPropertyForm.editable" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="值是否唯一" label-width="120px" prop="isOnly">
            <el-radio v-model="addPropertyForm.isOnly" label="1">是</el-radio>
            <el-radio v-model="addPropertyForm.isOnly" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="是否允许为空" label-width="120px" prop="nullable">
            <el-radio v-model="addPropertyForm.nullable" label="1">是</el-radio>
            <el-radio v-model="addPropertyForm.nullable" label="0">否</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addPropertyShow = false">取 消</el-button>
          <el-button type="primary" @click="addPropertyConfirm()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/javascript">
  //    import {getEntityTypeList1} from "../../api/abbNewApi";
  import elIconBtn from '@/components/module/iconBtns.vue'
  export default {
    //inject: ['reload'],
    components: {
      elIconBtn
    },
    props: [],
    data () {
      return {
        heights: document.getElementById('app').clientHeight-430,
        defaultProps: {
          children: 'children',
          label: 'typeName'
        },
        filterText: "",
        treeList: [],
        treeTableList: [],
        attributesList: [],
        editSuperiorShow: false, //编辑上级类型
        editSuperiorForm: {
          date: '',
          typeCode: '',
          typeName: '',
          editable: '',
          typeEnum: ''
          // isRank: '',
        },
        propertyShow: false,
        editPropertyForm: {
          propertyName: '',
          valueType: '',
          defaultValue: '',
          editable: '',
          nullable: ''
        },
        addSuperiorShow: false,
        addSuperiorForm: {
          typeName: '',
          typeCode: '',
          typeEnum: "0"
          // isRank: '0'
        },
        addType: '', //添加的类型
        addPropertyShow: false,
        addPropertyForm: {
          propertyName: '',
          typeCode: '',
          valueType: 0,
          defaultValue: '',
          editable: '1',
          isOnly: '1',
          nullable: '1',
        },
        search: '',
        getEntityTypeList: [], //树数据
        rules: {
          propertyName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          defaultValue: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
        },
        addRules: {
          typeName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],

        },
        editRules: {
          propertyName: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          typeCode: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          valueType: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          defaultValue: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          editable: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          isOnly: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
          nullable: [{
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }],
        },
        isShow: true,
        typeEnum: 0,
        attributesListCopy: []

      }
    },
    created () {
      debugPage=this
    },
    mounted () {
      //初始化数据

      this.$api.entityApi.getEntityTypeList(respon => {
        if(!isempty(respon)) {
          this.getEntityTypeList=deviceList(respon)
          this.treeTableList=[this.getEntityTypeList[0]]
          // this.$store.deviceStore.commit.setNowVirtualDevice(this.getEntityTypeList[0])
          this.initData(this.getEntityTypeList[0].typeCode)
        }
      })
      // this.isShow=this.$refs.eltree.isShow
    },
    destroyed () {},
    computed: {
      getValueEnum () {
        return this.$store.archivesStore.state.valueEnum
      },
      atrStyle () {
        let width='100%'
        if(this.isShow) {
          width='calc(100% - 2.26rem)'
        }
        return {
          "width": width
        }
      }
    },
    watch: {},
    methods: {
      search_fn () {
        this.attributesList=this.attributesListCopy.filter(data => !this.search||data.propertyName.toLowerCase().includes(this.search.toLowerCase()))
      },
      //筛选
      filterNode (value,data) {
        if(!value) return true;
        return data.name.indexOf(value)!==-1;
      },
      //编辑上级类型-赋值
      editSuperior (val) {
        console.log("val",val);
        this.editSuperiorShow=true
        this.editSuperiorForm=copy(val)
        this.editSuperiorForm.typeEnum=copy(val.typeEnum.toString())
      },
      initData (typeCode) {
        this.$api.entityApi.getTypePropertyList(typeCode,respon => {
          this.attributesListCopy=JSON.parse(JSON.stringify(respon))
          this.attributesList=respon
        })
      },
      getEntityList () {
        //获取树数据
        this.$api.entityApi.getEntityTypeList(respon => {
          if(!isempty(respon)) {
            this.getEntityTypeList=deviceList(respon)
          }

        })
      },
      checkItem (data) {
        this.treeTableList=[data]
        this.typeEnum=data.typeEnum
        if(data.typeEnum!=0) {
          this.initData(data.typeCode)
        } else {
          this.attributesList=[]
        }
      },
      //新添加子级
      newAddSuperior () {
        if(this.typeEnum==1) {
          this.$message({message: '请先修改此项为有子级，否则不能添加子级',type: 'warning'})
          return
        }
        this.addSuperiorShow=true
        this.addType='子级'
      },
      confirmSuperiorForm () {
        if(this.editSuperiorForm.typeName=="") {
          this.$message({message: '类型名称不能为空！',type: 'warning'})
          return
        }
        // console.log("确实修改",this.treeTableList[0].mainTypeCode);
        // return
        //确认修改上级编码
        this.$api.entityApi.updateEntityType(this.treeTableList[0].typeCode,this.editSuperiorForm.typeName,0,this.editSuperiorForm.typeEnum,this.treeTableList[0].mainTypeCode,'',respon => {
          if(!isempty(respon)) {
            this.getEntityList()
            this.$message({message: '修改成功',type: 'success'})
          }
        })
        this.editSuperiorShow=false
      },
      addConfirm () {
        if(this.addSuperiorForm.typeName=="") {
          this.$message({message: '类型名称不能为空！',type: 'warning'})
          return
        }
        if(this.addSuperiorForm.typeCode=="") {
          this.$message({message: '类型编码不能为空！',type: 'warning'})
          return
        }
        //确认添加上级或者同级
        if(this.addType=='同级') {
          //添加同级
          this.$api.entityApi.createEntityType(this.addSuperiorForm.typeCode,this.addSuperiorForm.typeName,this.addSuperiorForm.typeEnum,this.treeTableList[0].mainTypeCode,'',respon => {
            if(!isempty(respon)) {
              this.getEntityList()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        } else {
          //添加子级
          this.$api.entityApi.createEntityType(this.addSuperiorForm.typeCode,this.addSuperiorForm.typeName,this.addSuperiorForm.typeEnum,this.treeTableList[0].id,'',respon => {
            if(!isempty(respon)) {
              this.getEntityList()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
            }
          })
        }
        this.addSuperiorShow=false
      },
      editPropertyConfirm () {
        //确认修改属性
        let data=this.editPropertyForm
        this.$refs.editPropertyForm.validate((valid) => {
          if(valid) {
            this.$api.entityApi.updateTypeProperty(
              data.entityTypeCode,
              data.typePropertyCode,
              data.propertyName,
              data.valueType,
              data.readOnly,
              data.editable,
              data.isOnly,
              data.nullable,
              data.isVisiable,
              data.align,
              data.enumCode,
              data.sort,
              data.tag,
              data.formula,
              data.orderFlag,
              data.defaultValue,
              respon => {
                if(!isempty(respon)) {
                  this.initData(this.treeTableList[0].typeCode)
                  this.propertyShow=false
                  this.$message({
                    message: '修改成功',
                    type: 'success'
                  })
                }
              },err => {
                this.$message({
                  type: 'error',
                  message: err
                });
              })
          } else {
            return false;
          }
        })
      },
      editClick (item) {
        //打开编辑弹窗
        this.editPropertyForm=copy(item)
        this.editPropertyForm.editable=copy(item.editable.toString())
        this.editPropertyForm.nullable=copy(item.nullable.toString())
        this.editPropertyForm.isOnly=copy(item.isOnly.toString())
        this.propertyShow=true
      },
      addPropertyConfirm () {
        this.$refs.addPropertyForm.validate((valid) => {
          if(valid) {
            //确认添加属性
            this.$api.entityApi.createTypeProperty(
              this.treeTableList[0].typeCode,
              this.addPropertyForm.typeCode,
              this.addPropertyForm.propertyName,
              this.addPropertyForm.valueType,
              '',
              this.addPropertyForm.editable,
              this.addPropertyForm.isOnly,
              this.addPropertyForm.nullable,
              '',
              '',
              '',
              '',
              '',
              '',
              '',
              this.addPropertyForm.defaultValue,
              respon => {
                if(!isempty(respon)) {
                  this.addPropertyShow=false
                  this.$message({
                    type: 'success',
                    message: '添加成功!'
                  });
                  this.initData(this.treeTableList[0].typeCode)
                  //添加完成之后情况输入框的值
                  this.addPropertyForm.propertyName=''
                  this.addPropertyForm.typeCode=''
                  this.addPropertyForm.defaultValue=''
                }
              },err => {
                this.$message({
                  type: 'error',
                  message: err
                });
              })
          } else {
            return false;
          }
        });
      },
      deleteArchives (type,item) {
        //删除台账
        this.$confirm('此操作将永久删除该类型, 是否继续?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(type=='上级') {
            this.$api.entityApi.deleteEntityType(item.typeCode,respon => {
              if(!isempty(respon)) {
                this.getEntityList()
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
              }
            },err => {
              this.$message({
                type: 'error',
                message: err
              });
            })
          } else {
            //删除属性
            this.$api.entityApi.deleteTypeProperty(item.entityTypeCode,item.typePropertyCode,respon => {
              if(!isempty(respon)) {
                this.$message({
                  type: 'success',
                  message: '删除成功!'
                });
                this.initData(this.treeTableList[0].typeCode)
              }
            })
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      isEdit (value) {
        return value==0? false:true
      },
      //格式化内容
      formatEditable (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.editable===1? '是':'否'
      },
      formatValueType (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        if(!isempty(this.$store.archivesStore.state.valueEnum[row.valueType])) {
          return this.$store.archivesStore.state.valueEnum[row.valueType].text
        }
      },
      formatterIsOnly (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.isOnly===1? '是':'否'
      },
      formatterNullable (row,column,cellValue) {
        if(isempty(row)) {
          return
        }
        return row.nullable===1? '是':'否'
      }
    }
  }
</script>

<style scoped lang="scss">
  .archiverstype {
    .con {
      width: 100%;
      height: 100%;
      // background-color: #fff;
      box-sizing: border-box;
      display: flex;

      .left-tree {
        width: 300px;
        height: 100%;
        background-color: #fff;
        margin-right: 8px;
        padding: 12px;
        box-sizing: border-box;

        .btns {
          margin-top: 12px;
          margin-bottom: 5px;
        }

        /deep/.el-button {
          padding: 6px 11px !important;
        }
      }

      .public-flex {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right-table {
        width: calc(100% - 308px);
        height: 100%;

        .top-table {
          width: 100%;
          height: 170px;
          background-color: #fff;
          padding: 12px 20px;
          box-sizing: border-box;
          margin-bottom: 8px;
        }

        .bottom-table {
          width: 100%;
          height: calc(100% - 178px);
          background-color: #fff;
          box-sizing: border-box;
          padding: 12px 20px;
        }
      }
    }
  }
</style>